import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';

CustomNextArrow.propTypes = {
  onClick: PropTypes.func.isRequired,
};

CustomPrevArrow.propTypes = {
  onClick: PropTypes.func.isRequired,
};

function CustomPrevArrow(props) {
  const { onClick } = props;
  return (
    <button
      className="previous-arrow"
      onClick={onClick}
      type="button"
      label="none">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        style={{ width: '30px', height: '30px' }}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 19.5L8.25 12l7.5-7.5"
        />
      </svg>
    </button>
  );
}

function CustomNextArrow(props) {
  const { onClick } = props;

  return (
    <button className="next-arrow" onClick={onClick} type="button" label="none">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        style={{ width: '30px', height: '30px' }}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.25 4.5L15.75 12l-7.5 7.5"
        />
      </svg>
    </button>
  );
}

const settings = {
  dots: true,
  infinite: true,
  arrows: true,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
  dotsClass: 'slick-dots',
  fade: false,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 2000,
  slidesToShow: 1,
  slidesToScroll: 1,
  rows: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

Testimonials.propTypes = {
  testimonials: PropTypes.array.isRequired,
};

export default function Testimonials({ testimonials }) {
  return (
    <section>
      <header className="build-section-heading">
        <h2 className="underlined-heading">Testimonials</h2>
        <p>Trusted by Thousands of Market Enthusiasts</p>
      </header>
      <div className="testimonials-container">
        <div className="testimonials-svg1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="453"
            height="239"
            viewBox="0 0 453 239"
            fill="none">
            <path
              d="M-112.095 -52.824C-67.1474 -167.311 252.899 -344.944 413.14 -250.589C573.38 -156.234 200.295 -180.884 176.94 -55.2878C153.585 70.3081 285.133 200.866 78.2138 236.244C-87.3212 264.547 -157.042 61.6626 -112.095 -52.824Z"
              fill="#E8F0FF"
            />
          </svg>
        </div>
        {testimonials.length < 2 ? (
          <div className="testimonials-slider">
            {testimonials.map((testimonial) => (
              <div key={testimonials.title} className="testimonials-wrapper">
                <div className="testimonial-text-container">
                  <p className="testimonial-text">{testimonial.text}</p>
                  <h3 style={{ marginBottom: '5px', color: '#2C78F6' }}>
                    {testimonial.name}
                  </h3>
                  <p style={{ color: 'gray', marginBottom: '0px' }}>
                    {testimonial.title}
                  </p>
                </div>
                <div className="testimonial-image-container">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="testimonial-image"
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="testimonials-slider">
            <Slider className="testimonial-slider" {...settings}>
              {testimonials.map((testimonial) => (
                <div key={testimonials.title} className="testimonials-wrapper">
                  <div className="testimonial-text-container">
                    <p className="testimonial-text">{testimonial.text}</p>
                    <h3 style={{ marginBottom: '5px', color: '#2C78F6' }}>
                      {testimonial.name}
                    </h3>
                    <p style={{ color: 'gray', marginBottom: '0px' }}>
                      {testimonial.title}
                    </p>
                  </div>
                  <div className="testimonial-image-container">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="testimonial-image"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        )}

        <div className="testimonials-svg2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="490"
            height="364"
            viewBox="0 0 490 364"
            fill="none">
            <path
              d="M587.101 326.49C517.158 427.66 164.964 527.376 30.5554 398.869C-103.854 270.361 253.702 379.698 305.167 262.774C356.631 145.851 258.435 -11.3365 467.961 1.55447C635.581 11.8673 657.045 225.32 587.101 326.49Z"
              fill="#E8F0FF"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}
